<template>
  <div class="user-profile">
    <div
      v-if="isAuthenticated"
      class="user-profile__toggle-wrapper"
      :class="isImpersonating ? 'user-profile__impersonating' : ''"
      @click="showUserProfile = !showUserProfile"
    >
      <button class="user-profile__toggle-btn" type="button">
        <img :src="currentAvatar" class="user-profile__image" />
      </button>
      <ProfileToggler fill="#fff" class="user-profile__icon"></ProfileToggler>
    </div>
    <div class="user-profile__authenticate" v-else>
      <router-link class="btn__large" :to="{ name: 'login' }">
        Log In
        <span class="material-icons btn__large-icon">person</span>
      </router-link>
    </div>
    <transition name="fade">
      <user-profile-menu
        :profile="profile"
        :currentAvatar="currentAvatar"
        :isShown="showUserProfile"
        @closed="showUserProfile = false"
      ></user-profile-menu>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProfileToggler from '@/assets/icons/navigation/profile-toggler.svg'
import UserProfileMenu from './UserProfileMenu.vue'

export default {
  name: 'UserProfile',
  data() {
    return {
      showUserProfile: false,
    }
  },
  computed: {
    ...mapGetters({
      isImpersonating: 'auth/isImpersonating',
      currentAvatar: 'user/currentAvatar',
    }),
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    profile: {
      type: [Object, String],
      required: false,
    },
  },
  components: {
    ProfileToggler,
    UserProfileMenu,
  },
}
</script>

<style lang="scss" scoped>
.user-profile {
  $this: &;
  &__impersonating {
    border: 5px solid red !important;
  }
  &__toggle-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
    border-radius: 25px;
    padding: 0 12px 0 0;
    background-color: transparent;
    @include tablet {
      background-color: rgba(0, 0, 0, 0.3);
    }
    &:hover {
      cursor: pointer;
      #{this}__toggle-btn {
        color: var(--orange);
      }
      #{this}__icon {
        fill: var(--orange);
      }
    }
  }
  &__toggle-btn {
    border: none;
    background: transparent;
    color: var(--white);
    font-size: 50px;
    transition: 0.5s all ease;
    margin: 0;
    width: 40px;
    @include tablet {
      width: auto;
      margin: 15px -5px 0 -10px;
    }
    &:hover {
      cursor: pointer;
      #{this}__image {
        opacity: 0.8;
      }
    }
  }
  &__image {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    transition: 0.5s all ease;
    @include mobile {
      width: 50px;
      height: 50px;
    }
  }
  &__icon {
    width: 40px;
    transition: 0.5s all ease;
    fill: var(--white);
    display: none;
    @include mobile {
      display: block;
    }
  }
  .btn__large {
    padding: 5px 40px 5px 10px;
    @include tablet {
      padding: 8px 50px 8px 10px;
    }
  }
  .btn__large-icon {
    top: -1px;
    @include tablet {
      top: 3px;
    }
  }
}
</style>
